import Card from '../../components/Card';
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useT } from '../../utils/useTranslation';
import Pagination from '../../components/Pagination';
import api, { DB_TYPE } from '../../api';
import { db } from '../../firebase';
import { getDocs, collection, query, where, orderBy } from 'firebase/firestore';
import heroBg from '../../assets/sas_hero_new.png';
import ajrakTexture from '../../assets/ajrak_texture_new.jpg';
import { motion } from 'framer-motion';
import BookCard from '../../components/ui/BookCard';
import HeroBackground from '../../components/ui/HeroBackground';
const ITEMS_PER_PAGE = 12;
export default function BooksPage() {
  const t = useT();
  const [books, setBooks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState({
    type: '',
    language: '',
    search: ''
  });
  const [page, setPage] = useState(1);
  const navigate = useNavigate();
  const fetchBooks = async () => {
    setPage(1);
    if (DB_TYPE === 'firebase') {
      try {
        let q = collection(db, 'books');
        const constraints = [];
        if (filter.type) constraints.push(where('type', '==', filter.type));
        if (filter.language) constraints.push(where('language', '==', filter.language));
        
        const finalQuery = constraints.length > 0 ? query(q, ...constraints) : q;
        const snap = await getDocs(finalQuery);
        let all = snap.docs.map(d => ({ _id: d.id, ...d.data() }));
        
        if (filter.search) {
          const s = filter.search.toLowerCase();
          all = all.filter(b => 
            (b.title_en && b.title_en.toLowerCase().includes(s)) ||
            (b.title_sd && b.title_sd.includes(s)) ||
            (b.author_en && b.author_en.toLowerCase().includes(s)) ||
            (b.author_sd && b.author_sd.includes(s))
          );
        }
        setBooks(all);
        setLoading(false);
      } catch (err) {
        console.error(err);
        setLoading(false);
      }
    } else {
      const params = new URLSearchParams();
      if (filter.type) params.append('type', filter.type);
      if (filter.language) params.append('language', filter.language);
      if (filter.search) params.append('search', filter.search);
      api.get(`/books?${params}`).then(r => {
        setBooks(r.data);
        setLoading(false);
      }).catch(() => setLoading(false));
    }
  };
  useEffect(() => {
    fetchBooks();
  }, [filter.type, filter.language]);
  const typeIcon = t => ({
    book: '📗',
    journal: '📔',
    magazine: '📰'
  })[t] || '📄';
  return <>
    <div className="hero-premium" style={{
      minHeight: '400px',
      padding: '120px 2rem 100px'
    }}>
      <HeroBackground />

        <div style={{
          position: 'relative',
          zIndex: 10
        }}>
          <motion.h1 initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} className="text-gradient-gold" style={{
            fontSize: 56,
            fontWeight: 800,
            marginBottom: 16,
            letterSpacing: -1
          }}>
            {t('booksJournals')}
          </motion.h1>
          <p style={{
            color: 'rgba(255,255,255,0.7)',
            fontSize: 18,
            maxWidth: 600,
            margin: '0 auto',
            fontWeight: 500,
            lineHeight: 1.6
          }}>
            {t('booksSubtitle')}
          </p>
        </div>
      </div>

    <div style={{
      background: 'var(--sindhi-ivory)',
      backgroundImage: `url(${ajrakTexture})`,
      backgroundSize: '600px 600px',
      backgroundRepeat: 'repeat',
      position: 'relative',
      zIndex: 10,
      marginTop: '-50px'
    }}>
      <div style={{
        position: 'absolute',
        inset: 0,
        backdropFilter: 'blur(3px)',
        WebkitBackdropFilter: 'blur(3px)',
        background: 'rgba(253,248,235,0.7)',
        zIndex: 0,
        pointerEvents: 'none'
      }} />
      <div style={{
        maxWidth: 1200,
        margin: '0 auto',
        padding: '0 24px 100px',
        position: 'relative',
        zIndex: 1
      }}>
        {/* Filters */}
        <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} style={{
          display: 'flex',
          gap: 16,
          flexWrap: 'wrap',
          marginBottom: 60,
          background: 'rgba(255,255,255,0.85)',
          backdropFilter: 'blur(30px)',
          padding: '32px',
          borderRadius: 32,
          border: '1px solid rgba(255,255,255,0.5)',
          boxShadow: '0 30px 60px -12px rgba(0,0,0,0.1)'
        }}>
          <div style={{
            flex: 2,
            minWidth: 260,
            position: 'relative'
          }}>
            <span style={{
              position: 'absolute',
              left: 20,
              top: '50%',
              transform: 'translateY(-50%)',
              fontSize: 18,
              opacity: 0.5
            }}>🔍</span>
            <input className="form-input" placeholder={t('searchTitleAuthor')} style={{
              paddingLeft: 56,
              height: 60,
              borderRadius: 16,
              border: '1px solid var(--sindhi-gold-muted)',
              background: 'white',
              fontSize: 16,
              fontWeight: 500,
              boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.02)'
            }} value={filter.search} onChange={e => setFilter(p => ({
              ...p,
              search: e.target.value
            }))} onKeyDown={e => e.key === 'Enter' && fetchBooks()} />
          </div>
          <select className="form-input form-select" style={{
            width: 200,
            height: 60,
            borderRadius: 16,
            border: '1px solid var(--sindhi-gold-muted)',
            background: 'white',
            fontSize: 14,
            fontWeight: 700,
            padding: '0 20px',
            cursor: 'pointer'
          }} value={filter.type} onChange={e => setFilter(p => ({
            ...p,
            type: e.target.value
          }))}>
            <option value="">{t('allTypes')}</option>
            <option value="book">📗 {t('book')}</option>
            <option value="journal">📔 {t('journal')}</option>
            <option value="magazine">📰 {t('magazine')}</option>
          </select>
          <select className="form-input form-select" style={{
            width: 200,
            height: 60,
            borderRadius: 16,
            border: '1px solid var(--sindhi-gold-muted)',
            background: 'white',
            fontSize: 14,
            fontWeight: 700,
            padding: '0 20px',
            cursor: 'pointer'
          }} value={filter.language} onChange={e => setFilter(p => ({
            ...p,
            language: e.target.value
          }))}>
            <option value="">🌐 {t('allLanguages')}</option>
            <option value="sindhi">Sindhi</option>
            <option value="urdu">Urdu</option>
            <option value="english">English</option>
          </select>
          <motion.button whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="btn-premium" style={{
            padding: '0 40px',
            height: 60,
            fontSize: 15,
            fontWeight: 800
          }} onClick={fetchBooks}>
            {t('search')}
          </motion.button>
        </motion.div>

        {loading ? <div className="spinner" /> : books.length === 0 ? <Card style={{
          textAlign: 'center',
          padding: '80px 0',
          color: 'var(--sindhi-text-muted)'
        }}>
          <div style={{
            fontSize: 48,
            marginBottom: 16
          }}>📚</div>
          {t('noBooks')}
        </Card> : (() => {
          const totalPages = Math.ceil(books.length / ITEMS_PER_PAGE);
          const paged = books.slice((page - 1) * ITEMS_PER_PAGE, page * ITEMS_PER_PAGE);
          return <>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))',
              gap: 32
            }}>
              {paged.map((b, i) => (
                <BookCard key={b._id} book={b} index={i} onClick={() => navigate(`/books/${b._id}`)} />
              ))}
            </div>
            <Pagination page={page} totalPages={totalPages} onPageChange={p => {
              setPage(p);
              window.scrollTo({
                top: 400,
                behavior: 'smooth'
              });
            }} />
          </>;
        })()}
      </div>
    </div>
  </>;
}
export const typeIcon = t => ({
  book: '📗',
  journal: '📔',
  magazine: '📰'
})[t] || '📄';